import { getCookie, setCookie, domReady } from "../utils"

export default {
  init: function () {
    const t = this

    t.gdprBanner = document.getElementById("gdpr-banner")

    if (!t.gdprBanner) return

    t.showClassNames = ["bottom-0"]
    t.hideClassNames = ["-bottom-full"]
    t.consentBtn = t.gdprBanner.querySelector("[consent-button]")

    t.checkStatus()
  },

  checkStatus: function () {
    const t = this

    if (!getCookie('gdpr')) {
      domReady(() => {
        setTimeout(() => {
          t.showGdprBanner()
        }, 500)
      })

      t.consentBtn.addEventListener("click", () => {
        t.setConsentCookie()
        t.hideGdprBanner()
      })
    }
  },

  setConsentCookie: function () {
    setCookie("gdpr", "1", {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    })
  },

  showGdprBanner: function () {
    const t = this

    t.gdprBanner.classList.remove(...t.hideClassNames)
    t.gdprBanner.classList.add(...t.showClassNames)
  },

  hideGdprBanner: function () {
    const t = this

    t.gdprBanner.classList.remove(...t.showClassNames)
    t.gdprBanner.classList.add(...t.hideClassNames)
  },
}
